<template>
  <div class="card" v-show="currentCardId == 'skills-to-use'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>活かせるスキル・経験</h2>
        <p>
          応募先にアピールできるスキル（技能）や資格、経験などを入力しましょう
        </p>
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <div class="add-item"></div>
          <transition-group name="fade" tag="div">
            <HistoryItemSkill
              v-for="(item, index) in formatData.skillsToUse"
              :key="item.uuid"
              :item="item"
              :length="formatData.skillsToUse.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="' スキルや資格の名称を入力'"
              :descriptionPlaceholder2="' 習熟度や説明を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @click.native="activateHistoryItem(item.uuid)"
              @add-history-item="addSkillHistory"
              @delete-history-item="deleteSkillHistory"
              @move-history-item="moveSkillHistory"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addSkillHistory()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HistoryItemSkill from '@/components/formats/ShokurekishoParts/HistoryItemSkill.vue'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'
import { useProvidedShokurekishoHistories } from '@/composables/format-edit/useShokurekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'

defineProps<{
  currentCardId?: string
  basicData: BasicData
}>()

const descriptionMaxLength = 80
const formatData = useShokurekishoFormatData()
const {
  activeHistoryItem,
  addSkillHistory,
  deleteSkillHistory,
  moveSkillHistory,
  activateHistoryItem
} = useProvidedShokurekishoHistories()
</script>
